import store from '@/store/store'
import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'

export async function getPoLinesToRelieve (trxId, type) {
  const lines = store.getters[`get${capitalizeFirstLetter(type)}LinesByTransactionId`](trxId)
  let poLineIds = Object.values(lines).filter(line => line.relieves).map(line => line.relieves)
  let lineAccounts = Object.values(lines).filter(line => line.account).map(line => line.account)
  let thirdPartyVendorsIds = Object.values(lines).filter(line => line.third_party_vendor).map(line => line.third_party_vendor)

  if (!poLineIds.length && !lineAccounts.length && !thirdPartyVendorsIds.length) {
    return {}
  }
  let promises = []
  if (poLineIds.length) {
    promises.push(store.dispatch('fetchPoLinesWithQuery', { id__in: [...new Set(poLineIds)], page_size: poLineIds.length }))
  }
  if (lineAccounts.length) {
    promises.push(store.dispatch('fetchAccountsWithQuery', { id__in: [...new Set(lineAccounts)], page_size: lineAccounts.length }))
  }
  if (thirdPartyVendorsIds.length) {
    promises.push(store.dispatch('fetchVendorsWithQuery', { id__in: [...new Set(thirdPartyVendorsIds)], page_size: thirdPartyVendorsIds.length }))
  }
  return await Promise.all(promises)
}

export async function getOffsetDcJeLines (trxId, type) {
  let offsetPromises = Object.values(store.getters[`get${capitalizeFirstLetter(type)}LinesByTransactionId`](trxId))
    .filter(v => v.offset_by)
    .map(v => store.dispatch('fetchLinesById', {type: 'je', id: v.offset_by}))
  if (offsetPromises && offsetPromises.length) {
    const offsetResponse = await Promise.all(offsetPromises)
    let jes = []
    offsetResponse.forEach(v => Object.values(v.entities.lines).forEach(line => jes.push(line.transaction_id)))
    jes = [...new Set(jes)]
    const offsetJePromises = await Promise.all(jes.map(id => {
      return store.dispatch('fetchJeById', {id, storeLines: true})
        .then((r) => {
          if (r) {
            const jeLines = Object.values(store.getters.getJeLinesByTransactionId(id))
            store.dispatch('findDependencies', {lines: jeLines})
          }
        })
    }))
    await Promise.all(offsetJePromises)
  }
}

export async function loadInitialData () {
  let promises = []
  promises.push(store.dispatch('fetchSetsWithQuery', { page_size: 200 }))
  promises.push(store.dispatch('fetchSeriesWithQuery', { page_size: 200 }))
  promises.push(store.dispatch('fetchTaxcodesWithQuery', { page_size: 200 }))
  promises.push(store.dispatch('fetchLocationsWithQuery', { page_size: 200 }))
  promises.push(store.dispatch('fetchFreefieldsWithQuery', { page_size: 200 }))
  return await Promise.all(promises)
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/BeforeRouteEnterHelpers.js